module.exports = __webpack_public_path__ + "static/HOME_NUBE-SLOGAN-WANCLOUDS.b1bdbf3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/HOME_NUBE-SLOGAN-WANCLOUDS.png
// module id = 512
// module chunks = 35783957827783